import "./styles.css";

export const Preloader = () => {
  return (
    <div className="load">
      <hr />
      <hr />
      <hr />
      <hr />
    </div>
  );
};
